import React, { useState, useRef, useEffect, useMemo } from 'react';
import "../Css/ProductDetails.css";
import { FaHome } from 'react-icons/fa';
import { IoIosArrowForward } from 'react-icons/io';
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { IoMdCart } from "react-icons/io";
import { useParams } from 'react-router-dom';
import Footer from "../Component/Footer/Footer";
import { FiMinus, FiPlus } from 'react-icons/fi';
import product_image_not_found from "../Images/product_image_not_found.jpg";
import axios from 'axios';
import { useCartContext } from '../context/addToCart';
import { BallTriangle } from 'react-loader-spinner';

const ProductDetails = () => {
    const { slug } = useParams();
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const [mainImage, setMainImage] = useState('');
    const scrollRef = useRef(null);

    // State to manage quantity for EACH variant.
    // It will be an object where keys are variant indices or unique IDs, and values are quantities.
    const [variantQuantities, setVariantQuantities] = useState({});

    const { handleAddCart } = useCartContext();

    const handleFetch = async () => {
        try {
            setLoading(true);
            const resp = await axios.get(`https://api.woodsy.co.in/api/wood-images-product/${slug}`);
            if (resp?.data) setData(resp.data);
            console.log("details product",resp.data)
        } catch (error) {
            console.error(error);
            // Optionally set an error state here to display an error message
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        handleFetch();
    }, [slug]);

    // Effect to set initial main image and initialize variant quantities
    useEffect(() => {
        if (data?.images?.length > 0) {
            setMainImage(data.images[0]);
        } else {
            setMainImage(product_image_not_found);
        }

        // Initialize quantities for each variant to 1
        if (data?.price && data.price.length > 0) {
            const initialQuantities = {};
            data.price.forEach((_, index) => {
                initialQuantities[index] = 1; // Use index as a simple key for now
            });
            setVariantQuantities(initialQuantities);
        }
    }, [data]);

    // Scroll handlers
    const scrollLeft = () => {
        if (scrollRef.current) scrollRef.current.scrollBy({ left: -100, behavior: 'smooth' });
    };

    const scrollRight = () => {
        if (scrollRef.current) scrollRef.current.scrollBy({ left: 100, behavior: 'smooth' });
    };

    // Quantity handlers for specific variants
    const incrementVariantQuantity = (index) => {
        setVariantQuantities(prevQuantities => ({
            ...prevQuantities,
            [index]: (prevQuantities[index] || 1) + 1
        }));
    };

    const decrementVariantQuantity = (index) => {
        setVariantQuantities(prevQuantities => ({
            ...prevQuantities,
            [index]: Math.max(1, (prevQuantities[index] || 1) - 1)
        }));
    };

    const handleAddToCartClick = (variantItem, quantity) => {
        if (!variantItem || quantity < 1) {
            alert("Invalid item or quantity.");
            return;
        }

        const productToAdd = {
            productName: data?.product?.name,
            productCategory: data?.main_category?.name,
            productSubCategory: data?.sub_category?.name,
            productBrand: data?.brand?.name,
            productHsn: data?.product?.hsn_code, // Assuming 'hsn_code' is the field name
            product_price: variantItem.price, // Use this variant's price
            productThickness: variantItem.thickness,
            productSize: variantItem.size,
            productQuantity: quantity.toString(),
            productImage: mainImage,
            productId: data?.product?.id,
            productCategoryId: data?.main_category?.id,
            productSubcategoryId: data?.sub_category?.id,
            productBrandId: data?.brand?.id,
            // You might want to add a unique variant ID if your backend provides one for cart management
            // variantId: variantItem.id // if price object has its own ID
        };
        handleAddCart(productToAdd);
    };

    if (loading) {
        return (
            <div className='loading-container' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
                <BallTriangle
                    height={100}
                    width={100}
                    radius={5}
                    color="#007bff"
                    ariaLabel="ball-triangle-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                />
            </div>
        );
    }

    // Images array for rendering thumbnails
    const images = data?.images?.length > 0 ? data.images : [product_image_not_found];
console.log("data deatils page",data)
    return (
        <div>
            <section className='Product-section-banner'>
                <div className='container'>
                    <div className='Product-section-banner-main-con'>
                        <div className='Product-section-banner-con'>
                            <h2>Product Details</h2>
                            <div className='Product-section-banner-content'>
                                <FaHome />
                                <IoIosArrowForward />
                                <span>Product Details</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='product-details-section-2'>
                <div className='container'>
                    <div className='product-details-section-2-main-con'>
                        <div className='row'>
                            <div className='col-md-5'>
                                <div className='product-details-2-images-main-con'>
                                    <div className='product-details-2-image-main-image-con'>
                                        <div className='product-details-2-image-main-image'>
                                            <img src={mainImage} alt="Main" style={{ width: '100%', height: 'auto' }} />
                                        </div>
                                    </div>
                                    <div className='product-details-2-other-images-main-con'>
                                        <div className='product-details-2-other-backward-btn-main-con' onClick={scrollLeft}>
                                            <div className='product-details-2-other-backward-btn-icon-con'><IoChevronBack /></div>
                                        </div>
                                        <div className='product-details-2-other-mid-images-main-con' ref={scrollRef} style={{ overflowX: 'auto', display: 'flex' }}>
                                            {images.map((img, index) => (
                                                <div key={index} className='product-details-2-other-mid-images' style={{ cursor: 'pointer', marginRight: '10px' }} onClick={() => setMainImage(img)}>
                                                    <img src={img} alt={`Thumb ${index}`} width={60} />
                                                </div>
                                            ))}
                                        </div>
                                        <div className='product-details-2-other-forward-btn-main-con' onClick={scrollRight}>
                                            <div className='product-details-2-other-backward-btn-icon-con'><IoChevronForward /></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='col-md-6'>
                                <div className='product-details-2-main-info-con'>
                                    <div className='product-details-page-brand-image-name-con'>
                                        <div className='product-details-page-main-image-con'>
                                            <img src={data?.brand?.image} alt={data?.brand?.name} />
                                        </div>
                                        <div className='product-details-page-main-name-con'>
                                            <h2>{data?.brand?.name}</h2> <span>/</span> <h2>{data?.sub_category?.name}</h2>
                                        </div>
                                    </div>

                                    {/* Product Features */}
                                    <div className='product-details-2-points-main-con'>
                                        {data?.product?.feature && (
                                            <div className='product-details-2-points-con'>
                                                <div className='product-details-2-points-head'><h5>Furniture:</h5></div>
                                                <div className='product-details-2-points-head'><h6>{data.product.feature}</h6></div>
                                            </div>
                                        )}
                                        {data?.product?.usage && (
                                            <div className='product-details-2-points-con'>
                                                <div className='product-details-2-points-head'><h5>Usage:</h5></div>
                                                <div className='product-details-2-points-head'><h6>{data.product.usage}</h6></div>
                                            </div>
                                        )}
                                        {data?.product?.woodtype && (
                                            <div className='product-details-2-points-con'>
                                                <div className='product-details-2-points-head'><h5>Wood Type:</h5></div>
                                                <div className='product-details-2-points-head'><h6>{data.product.woodtype}</h6></div>
                                            </div>
                                        )}
                                        {data?.product?.corematerial && (
                                            <div className='product-details-2-points-con'>
                                                <div className='product-details-2-points-head'><h5>Core Material:</h5></div>
                                                <div className='product-details-2-points-head'><h6>{data.product.corematerial}</h6></div>
                                            </div>
                                        )}
                                    </div>

                                    {/* --- Per-Variant Display with Quantity and Add to Cart --- */}
                                    {data?.price?.length > 0 ? (
                                        <div className="product-variants-list-per-item">
                                            <h4>Available Variants:</h4>
                                            {data.price.map((variantItem, index) => {
                                                const thicknessDisplay = variantItem.thickness ? `${variantItem.thickness}` : '';
                                                const sizeDisplay = variantItem.size ? `${variantItem.size}` : '';

                                                let variantString = '';
                                                if (thicknessDisplay && sizeDisplay) {
                                                    variantString = `${thicknessDisplay} / ${sizeDisplay}`;
                                                } else if (thicknessDisplay) {
                                                    variantString = `${thicknessDisplay}`;
                                                } else if (sizeDisplay) {
                                                    variantString = `Size: ${sizeDisplay}`;
                                                } else {
                                                    variantString = 'Default Variant'; // Fallback if neither exists
                                                }

                                                const currentQuantity = variantQuantities[index] || 1; // Get quantity for this specific variant

                                                return (
                                                    <div key={index} className="variant-item-row">
                                                        <div className="variant-details">
                                                            <span>
                                                                {variantString} = ₹{parseFloat(variantItem.price).toFixed(2)}
                                                            </span>
                                                            <p style={{color:"#836430",fontWeight:"600",margin:"0px"}}>({variantItem?.tags})</p>
                                                        </div>

                                                        <div className='variant-quantity-add-to-cart'>
                                                            <div className='quantity-counter-box'>
                                                                <button onClick={() => decrementVariantQuantity(index)}><FiMinus /></button>
                                                                <h3>{currentQuantity}</h3>
                                                                <button onClick={() => incrementVariantQuantity(index)}><FiPlus /></button>
                                                            </div>
                                                            <div className='add-to-cart-button-wrapper'>
                                                                <IoMdCart />
                                                                <button onClick={() => handleAddToCartClick(variantItem, currentQuantity)}>Add To Cart</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ) : (
                                        <p>No specific variants available for this product.</p>
                                    )}
                                    {/* --- END Per-Variant Display --- */}

                                </div>
                            </div>
                        </div>

                        <div className='product-details-2-main-info-con-second'>
                            {/* You can place the product name here or higher up as per your design preference */}
                            <h2>{data?.product?.name || "Product Title"}</h2>
                            <div
                                dangerouslySetInnerHTML={{ __html: data?.product?.description || "No description available." }}
                            ></div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};
export default ProductDetails;